import reducer from './reducers';
import * as deviceTypes from './types';

export { deviceTypes };

export default reducer;
